import React, { FC, Fragment } from 'react';

import { useTranslation } from 'react-i18next';
import { Tooltip, Box } from '@mui/material';

type ActiveIndicatorProps = {
    isActive: boolean;
};

const ActiveIndicator: FC<ActiveIndicatorProps> = ({ isActive }: ActiveIndicatorProps) => {
    const { t: translate } = useTranslation(['common']);
    const statusTitle = isActive ? translate('common:ACTIVE') : translate('common:INACTIVE');

    return (
        <Fragment>
            <Tooltip title={statusTitle}>
                <Box
                    sx={{
                        backgroundColor: isActive ? 'success.main' : 'error.main',
                        width: '10px',
                        height: '10px',
                        borderRadius: '100%',
                        display: 'inline-block',
                    }}
                ></Box>
            </Tooltip>
        </Fragment>
    );
};
export default ActiveIndicator;
